export default {
      id: "email-usage",
      viewBox: "0 0 449 292",
      url: "../../assets/" + "sprite.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }